import HashWorker from "./hashWorker?worker&inline";

/**
 * Compute SHA-256 hash of a file using a Web Worker.
 * File reading and hashing run off the main thread to avoid UI blocking.
 *
 * Uses Vite's `?worker&inline` import to embed the worker script as a Blob URL,
 * avoiding cross-origin errors when assets are served from a different CDN origin.
 */
export function computeFileHash(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const worker = new HashWorker();

    worker.onmessage = (e: MessageEvent<string>) => {
      resolve(e.data);
      worker.terminate();
    };

    worker.onerror = (e) => {
      reject(new Error(`Hash worker error: ${e.message}`));
      worker.terminate();
    };

    worker.postMessage(file);
  });
}
